export const ptsFormula = (netAmt, userBasisPts) => {
    const userbasisPoints = userBasisPts / 100
    const dollarPerBasisPoint = userbasisPoints * netAmt
    const floorDollarPerBassisPts = Math.sign(dollarPerBasisPoint) * Math.abs(dollarPerBasisPoint)
    let formattedPts = Math.floor(floorDollarPerBassisPts*100) / 100

    return formattedPts
}